import Container from "../Common/Container";

export default function ArtistProfileInfo({ info }) {
  const data = info?.data;

  const shareLink = async () => {
    let shareData = {
      url: window.location.href,
    };
    if (navigator && navigator.share) {
      await navigator.share(shareData);
    }
  };

  function getSvgOrImage(platform) {
    switch (platform) {
      case "instagram":
        return (
          <svg
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 10.5C14.8133 10.5 13.6533 10.8519 12.6666 11.5112C11.6799 12.1705 10.9108 13.1075 10.4567 14.2039C10.0026 15.3003 9.88378 16.5067 10.1153 17.6705C10.3468 18.8344 10.9182 19.9035 11.7574 20.7426C12.5965 21.5818 13.6656 22.1532 14.8295 22.3847C15.9933 22.6162 17.1997 22.4974 18.2961 22.0433C19.3925 21.5892 20.3295 20.8201 20.9888 19.8334C21.6481 18.8467 22 17.6867 22 16.5C22 14.9087 21.3679 13.3826 20.2426 12.2574C19.1174 11.1321 17.5913 10.5 16 10.5ZM16 20.5C15.2089 20.5 14.4355 20.2654 13.7777 19.8259C13.1199 19.3864 12.6072 18.7616 12.3045 18.0307C12.0017 17.2998 11.9225 16.4956 12.0769 15.7196C12.2312 14.9437 12.6122 14.231 13.1716 13.6716C13.731 13.1122 14.4437 12.7312 15.2196 12.5769C15.9956 12.4225 16.7998 12.5017 17.5307 12.8045C18.2616 13.1072 18.8864 13.6199 19.3259 14.2777C19.7654 14.9355 20 15.7089 20 16.5C19.9967 17.5599 19.5742 18.5754 18.8248 19.3248C18.0754 20.0742 17.0599 20.4967 16 20.5ZM21.5 4H10.5C8.64348 4 6.86301 4.7375 5.55025 6.05025C4.2375 7.36301 3.5 9.14348 3.5 11V22C3.5 23.8565 4.2375 25.637 5.55025 26.9497C6.86301 28.2625 8.64348 29 10.5 29H21.5C23.3565 29 25.137 28.2625 26.4497 26.9497C27.7625 25.637 28.5 23.8565 28.5 22V11C28.5 9.14348 27.7625 7.36301 26.4497 6.05025C25.137 4.7375 23.3565 4 21.5 4ZM26.5 22C26.5 22.6566 26.3707 23.3068 26.1194 23.9134C25.8681 24.52 25.4998 25.0712 25.0355 25.5355C24.5712 25.9998 24.02 26.3681 23.4134 26.6194C22.8068 26.8707 22.1566 27 21.5 27H10.5C9.84339 27 9.19321 26.8707 8.58658 26.6194C7.97996 26.3681 7.42876 25.9998 6.96447 25.5355C6.50017 25.0712 6.13188 24.52 5.8806 23.9134C5.62933 23.3068 5.5 22.6566 5.5 22V11C5.5 9.67392 6.02678 8.40215 6.96447 7.46447C7.90215 6.52678 9.17392 6 10.5 6H21.5C22.1566 6 22.8068 6.12933 23.4134 6.3806C24.02 6.63188 24.5712 7.00017 25.0355 7.46447C25.4998 7.92876 25.8681 8.47996 26.1194 9.08658C26.3707 9.69321 26.5 10.3434 26.5 11V22ZM24 10C24 10.2967 23.912 10.5867 23.7472 10.8334C23.5824 11.08 23.3481 11.2723 23.074 11.3858C22.7999 11.4994 22.4983 11.5291 22.2074 11.4712C21.9164 11.4133 21.6491 11.2704 21.4393 11.0607C21.2296 10.8509 21.0867 10.5836 21.0288 10.2926C20.9709 10.0017 21.0007 9.70006 21.1142 9.42597C21.2277 9.15189 21.42 8.91762 21.6666 8.7528C21.9133 8.58797 22.2033 8.5 22.5 8.5C22.8978 8.5 23.2794 8.65804 23.5607 8.93934C23.842 9.22064 24 9.60218 24 10Z"
              fill="#E5E5E5"
            />
          </svg>
        );
      case "twitter" || "x":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="33"
            viewBox="0 0 256 256"
          >
            <g
              fill="#ffffff"
              fillRule="nonzero"
              stroke="none"
              strokeWidth="1"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeMiterlimit="10"
              strokeDasharray=""
              strokeDashoffset="0"
              fontFamily="none"
              fontWeight="none"
              fontSize="none"
              textAnchor="none"
              style={{ mixBlendMode: "normal" }}
            >
              <g transform="scale(8.53333,8.53333)">
                <path d="M26.37,26l-8.795,-12.822l0.015,0.012l7.93,-9.19h-2.65l-6.46,7.48l-5.13,-7.48h-6.95l8.211,11.971l-0.001,-0.001l-8.66,10.03h2.65l7.182,-8.322l5.708,8.322zM10.23,6l12.34,18h-2.1l-12.35,-18z"></path>
              </g>
            </g>
          </svg>
        );
      case "spotify":
        return (
          <svg
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_3775_14725)">
              <path
                d="M16 4.5C9.371 4.5 4 9.871 4 16.5C4 23.129 9.371 28.5 16 28.5C22.629 28.5 28 23.129 28 16.5C28 9.871 22.629 4.5 16 4.5ZM16 6.5C17.3147 6.49471 18.6174 6.74976 19.8331 7.25043C21.0487 7.7511 22.1532 8.48749 23.0829 9.41714C24.0125 10.3468 24.7489 11.4513 25.2496 12.6669C25.7502 13.8826 26.0053 15.1853 26 16.5C26.0053 17.8147 25.7502 19.1174 25.2496 20.3331C24.7489 21.5487 24.0125 22.6532 23.0829 23.5829C22.1532 24.5125 21.0487 25.2489 19.8331 25.7496C18.6174 26.2502 17.3147 26.5053 16 26.5C14.6853 26.5053 13.3826 26.2502 12.1669 25.7496C10.9513 25.2489 9.84678 24.5125 8.91714 23.5829C7.98749 22.6532 7.2511 21.5487 6.75043 20.3331C6.24976 19.1174 5.99471 17.8147 6 16.5C5.99471 15.1853 6.24976 13.8826 6.75043 12.6669C7.2511 11.4513 7.98749 10.3468 8.91714 9.41714C9.84678 8.48749 10.9513 7.7511 12.1669 7.25043C13.3826 6.74976 14.6853 6.49471 16 6.5ZM14.406 11.25C12.461 11.25 10.766 11.43 9.156 11.938C8.73 12.023 8.375 12.344 8.375 12.938C8.375 13.531 8.813 14.055 9.406 13.968C9.66 13.968 9.832 13.875 10 13.875C11.355 13.535 12.883 13.375 14.406 13.375C17.367 13.375 20.406 14.035 22.437 15.219C22.691 15.305 22.777 15.406 23.031 15.406C23.625 15.406 24.039 14.969 24.125 14.375C24.125 13.867 23.871 13.543 23.531 13.375C20.992 11.937 17.621 11.25 14.406 11.25ZM14.125 14.969C12.348 14.969 11.082 15.223 9.812 15.563C9.391 15.73 9.156 15.993 9.156 16.5C9.156 16.922 9.492 17.344 10 17.344C10.172 17.344 10.246 17.336 10.5 17.25C11.43 16.996 12.707 16.844 14.063 16.844C16.855 16.844 19.285 17.524 21.063 18.625C21.23 18.711 21.403 18.781 21.656 18.781C22.164 18.781 22.5 18.351 22.5 17.844C22.5 17.504 22.34 17.168 22 17C19.8 15.645 17.004 14.969 14.125 14.969ZM14.406 18.625C12.969 18.625 11.606 18.785 10.25 19.125C9.91 19.211 9.656 19.453 9.656 19.875C9.656 20.215 9.922 20.563 10.344 20.563C10.43 20.563 10.676 20.469 10.844 20.469C11.9814 20.2038 13.1451 20.0672 14.313 20.062C16.426 20.062 18.359 20.57 19.969 21.5C20.141 21.586 20.332 21.656 20.5 21.656C20.84 21.656 21.164 21.402 21.25 21.063C21.25 20.637 21.066 20.48 20.812 20.313C18.949 19.211 16.773 18.625 14.406 18.625Z"
                fill="#E5E5E5"
              />
            </g>
            <defs>
              <clipPath id="clip0_3775_14725">
                <rect
                  width="32"
                  height="32"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "youtube":
        return (
          <svg
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.6667 16.4997L14 19.1663V13.833L18.6667 16.4997Z"
              fill="#E5E5E5"
              stroke="#E5E5E5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.66699 17.4425V15.5559C2.66699 11.6959 2.66699 9.7652 3.87366 8.52387C5.08166 7.2812 6.98299 7.22787 10.7843 7.11987C12.5843 7.0692 14.4243 7.0332 16.0003 7.0332C17.575 7.0332 19.415 7.0692 21.2163 7.11987C25.0177 7.22787 26.919 7.2812 28.1257 8.52387C29.3337 9.7652 29.3337 11.6972 29.3337 15.5559V17.4425C29.3337 21.3039 29.3337 23.2332 28.127 24.4759C26.919 25.7172 25.019 25.7719 21.2163 25.8785C19.4163 25.9305 17.5763 25.9665 16.0003 25.9665C14.2613 25.9613 12.5225 25.932 10.7843 25.8785C6.98299 25.7719 5.08166 25.7185 3.87366 24.4759C2.66699 23.2332 2.66699 21.3025 2.66699 17.4439V17.4425Z"
              stroke="#E5E5E5"
              strokeWidth="2"
            />
          </svg>
        );
      case "soundcloud":
        return (
          <svg
            width="32"
            height="30"
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M31.9313 16.8635C31.9313 19.3557 29.7 21.3777 26.95 21.3777H24.9563C24.4063 21.3777 23.9625 20.9756 23.9625 20.4771C23.9625 19.9787 24.4063 19.5766 24.9563 19.5766H26.95C28.6 19.5766 29.9375 18.3645 29.9375 16.8691C29.9375 15.3738 28.6 14.1617 26.95 14.1617H26.9375C25.6438 14.1617 24.5375 13.4141 24.125 12.3719C24.125 12.3662 24.1125 12.3606 24.1125 12.3492C23.3375 10.3725 21.3312 8.92249 18.925 8.7639C18.4062 8.79222 17.9937 9.18301 17.9937 9.65879V20.4715C17.9937 20.9699 17.55 21.3721 17 21.3721C16.45 21.3721 16.0062 20.9699 16.0062 20.4715V9.65879C16.0062 8.1748 17.325 6.974 18.9562 6.95703C22.2062 7.12695 24.9312 9.0584 25.9812 11.7205C25.9875 11.7262 25.9937 11.7318 26 11.7318C26.1313 12.0943 26.5063 12.3549 26.9438 12.3549H26.9563C27.0125 12.3549 27.0688 12.3605 27.1188 12.3605H27.15C29.8063 12.4568 31.9313 14.4336 31.9313 16.8635V16.8635ZM13.0125 21.3777C12.4625 21.3777 12.0188 20.9756 12.0188 20.4771V10.548C12.0188 10.0496 12.4625 9.64746 13.0125 9.64746C13.5625 9.64746 14.0063 10.0496 14.0063 10.548V20.4771C14.0063 20.9699 13.5625 21.3777 13.0125 21.3777ZM9.02504 21.3777C8.47504 21.3777 8.03129 20.9755 8.03129 20.4771V10.0949C8.03129 9.59646 8.47504 9.19431 9.02504 9.19431C9.57504 9.19431 10.0188 9.59646 10.0188 10.0949V20.4715C10.025 20.9699 9.57504 21.3777 9.02504 21.3777ZM5.04376 21.3777C4.49376 21.3777 4.05001 20.9755 4.05001 20.4771V13.2554C4.05001 12.757 4.49376 12.3548 5.04376 12.3548C5.59376 12.3548 6.03751 12.757 6.03751 13.2554V20.4771C6.03751 20.9699 5.59376 21.3777 5.04376 21.3777ZM1.06251 19.5708C0.512506 19.5708 0.0687561 19.1687 0.0687561 18.6702V15.0622C0.0687561 14.5638 0.512506 14.1616 1.06251 14.1616C1.61251 14.1616 2.05626 14.5638 2.05626 15.0622V18.6702C2.05626 19.1687 1.61251 19.5708 1.06251 19.5708ZM20.975 19.5708C21.525 19.5708 21.9688 19.973 21.9688 20.4714C21.9688 20.9698 21.525 21.372 20.975 21.372C20.425 21.372 19.9813 20.9698 19.9813 20.4714C19.9813 19.973 20.425 19.5708 20.975 19.5708Z"
              fill="#E5E5E5"
            />
          </svg>
        );
      default:
        // fallback to image (assumes /images/socials/[platform].png exists)
        return (
          <img
            src={`/assets/icons/${platform}.png`}
            alt={platform}
            width={32}
            height={32}
            style={{ objectFit: "contain" }}
          />
        );
    }
  }

  return (
    <div className=" relative ">
      <Container className=" lg:pl-[153px] lg:pt-[100px] lg:pr-[150px] flex justify-center relative  lg:justify-start gap-[90px] ">
        <div className="absolute  lg:top-[100px] left-0 w-full  z-[99] ">
          <div className="lg:flex hidden justify-end lg:pb-[64px] lg:pt-[30px] lg:px-[87.5px]">
            <button
              onClick={shareLink}
              className="flex items-center gap-[10px] px-6 py-3 border border-white rounded-[10px] "
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.18387 13.3419C9.38616 12.9381 9.5 12.4824 9.5 12C9.5 11.5176 9.38616 11.0619 9.18387 10.6581M9.18387 13.3419C8.69134 14.3251 7.67449 15 6.5 15C4.84315 15 3.5 13.6569 3.5 12C3.5 10.3431 4.84315 9 6.5 9C7.67449 9 8.69134 9.67492 9.18387 10.6581M9.18387 13.3419L15.8161 16.6581M9.18387 10.6581L15.8161 7.34193M15.8161 7.34193C16.3087 8.32508 17.3255 9 18.5 9C20.1569 9 21.5 7.65685 21.5 6C21.5 4.34315 20.1569 3 18.5 3C16.8431 3 15.5 4.34315 15.5 6C15.5 6.48237 15.6138 6.93815 15.8161 7.34193ZM15.8161 16.6581C15.6138 17.0619 15.5 17.5176 15.5 18C15.5 19.6569 16.8431 21 18.5 21C20.1569 21 21.5 19.6569 21.5 18C21.5 16.3431 20.1569 15 18.5 15C17.3255 15 16.3087 15.6749 15.8161 16.6581Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p className=" lg:text-[14px] font-[700] leading-[22px]  mb-0 ">
                Share
              </p>
            </button>
          </div>
        </div>

        <div className=" hidden lg:block lg:pt-[35px] lg:pb-[20px] relative z-[99] ">
          <div className="  rounded-full   pt-[1px] pb-[46px] pr-[83px] ">
            <img
              src={info?.data.profile}
              alt=""
              className="lg:w-[280px] lg:h-[280px] lg:aspect-square border border-[#FFFFFF] rounded-full  "
            />
          </div>
        </div>
        <div className=" relative z-[999] lg:pt-[35px] lg:pl-6 lg:pb-[80px] ">
          <p className="hidden lg:block mb-0 lg:text-[40px] max-w-[500px] lg:leading-[42px] font-[700] ">
            {data?.name}
          </p>
          <div className="hidden lg:pt-[42px] lg:flex flex-col lg:gap-5 ">
            <div className="flex items-center gap-[22px] ">
              <p>
                <svg
                  width="23"
                  height="24"
                  viewBox="0 0 23 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.24707 10.5887C3.24707 6.19221 6.81278 2.63867 11.1259 2.63867C15.4511 2.63867 19.0168 6.19221 19.0168 10.5887C19.0168 12.8042 18.2348 14.861 16.9477 16.6043C15.5278 18.5273 13.7777 20.2028 11.8078 21.5179C11.3569 21.8219 10.95 21.8448 10.4552 21.5179C8.47403 20.2028 6.72391 18.5273 5.31615 16.6043C4.02812 14.861 3.24707 12.8042 3.24707 10.5887ZM8.52922 10.8363C8.52922 12.3091 9.69565 13.4675 11.1259 13.4675C12.557 13.4675 13.7347 12.3091 13.7347 10.8363C13.7347 9.37492 12.557 8.16014 11.1259 8.16014C9.69565 8.16014 8.52922 9.37492 8.52922 10.8363Z"
                    fill="#FAFAFA"
                  />
                </svg>
              </p>
              <p className=" lg:text-2xl text-[#E0E0E0] leading-[34px] ">
                {data?.city}, {data?.state}
              </p>
            </div>
            <div
              className={`flex items-center gap-[22px] ${
                !data.account_type ? "hidden" : ""
              } `}
            >
              <p>
                <svg
                  width="23"
                  height="24"
                  viewBox="0 0 23 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.294 15.2718H10.9696C8.74019 15.2718 6.93309 13.4322 6.93309 11.1647V6.74578C6.93309 4.47736 8.74019 2.63867 10.9696 2.63867H11.294C13.5235 2.63867 15.3315 4.47736 15.3315 6.74578V11.1647C15.3315 13.4322 13.5235 15.2718 11.294 15.2718ZM17.2196 11.0333C17.2196 10.5277 17.6222 10.119 18.1182 10.119C18.6142 10.119 19.0168 10.5277 19.0168 11.0333C19.0168 15.1468 15.9561 18.5435 12.031 18.9997V20.8402C12.031 21.3449 11.6284 21.7546 11.1324 21.7546C10.6355 21.7546 10.2338 21.3449 10.2338 20.8402V18.9997C6.30774 18.5435 3.24707 15.1468 3.24707 11.0333C3.24707 10.5277 3.64965 10.119 4.14568 10.119C4.64172 10.119 5.04429 10.5277 5.04429 11.0333C5.04429 14.4483 7.77518 17.2269 11.1324 17.2269C14.4887 17.2269 17.2196 14.4483 17.2196 11.0333Z"
                    fill="white"
                  />
                </svg>
              </p>
              <p className=" lg:text-2xl text-[#E0E0E0] leading-[34px] ">
                {data?.account_type}
              </p>
            </div>
            <div
              className={`flex items-center gap-[22px] ${
                !data?.genre && "hidden"
              } `}
            >
              <p>
                <svg
                  width="23"
                  height="24"
                  viewBox="0 0 23 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4116 8.81782C16.2229 10.6841 16.2229 13.71 14.4116 15.5763M17.0353 6.11436C20.2957 9.47371 20.2957 14.9203 17.0353 18.2796M5.18186 15.0645H3.71083C3.19852 15.0645 2.7832 14.6366 2.7832 14.1087V10.2855C2.7832 9.75764 3.19852 9.32972 3.71083 9.32972H5.18186L9.54832 4.83069C10.1327 4.22857 11.1319 4.65502 11.1319 5.50654V18.8877C11.1319 19.7392 10.1327 20.1656 9.54832 19.5635L5.18186 15.0645Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </p>
              <p className=" lg:text-2xl text-[#E0E0E0] leading-[34px] ">
                {data?.genre}
              </p>
            </div>
          </div>

          <div className="mt-[20px] mb-[30px] lg:mb-0 lg:mt-[34px] flex justify-start w-full gap-[41px]">
            <div className="mt-[20px] mb-[30px] lg:mb-0 lg:mt-[34px] flex justify-start w-full gap-[41px]">
              {(() => {
                const socials = data?.social || [];

                const FALLBACK_DEFAULTS = [
                  "instagram",
                  "youtube",
                  "spotify",
                  "apple_music",
                  "tiktok",
                ];
                const MAX_ICONS = 5;

                // Step 1: Collect all active social items
                const activeItems = [];
                const fallbackUsed = new Set();

                for (const item of socials) {
                  const name = item.name.toLowerCase();
                  if (
                    item.status === 1 &&
                    !activeItems.find((i) => i.name.toLowerCase() === name)
                  ) {
                    activeItems.push(item);
                    fallbackUsed.add(name);
                  }
                  if (activeItems.length === MAX_ICONS) break;
                }

                // If we already have 5 active, show only those
                if (activeItems.length === MAX_ICONS) {
                  return activeItems.map((item) => (
                    <div
                      key={item.name}
                      className="cursor-pointer"
                      onClick={() => {
                        if (item.link) window.open(item.link, "_blank");
                      }}
                    >
                      {getSvgOrImage(item.name)}
                    </div>
                  ));
                }

                // Step 2: Add fallback items if active < 5
                const fallbackItems = [];
                const remainingSlots = MAX_ICONS - activeItems.length;

                for (const name of FALLBACK_DEFAULTS) {
                  if (fallbackUsed.has(name)) continue;

                  const existing = socials.find(
                    (s) => s.name.toLowerCase() === name
                  );

                  if (existing) {
                    fallbackItems.push(existing); // existing inactive one
                  } else {
                    fallbackItems.push({
                      name,
                      status: 0,
                      link: null,
                    });
                  }

                  if (fallbackItems.length === remainingSlots) break;
                }

                const finalItems = [...activeItems, ...fallbackItems];

                return finalItems.map((item) => {
                  const isActive = item.status === 1;
                  const isAvailable = !!item.link;
                  const shouldGrayOut = !isActive
                    ? "filter grayscale brightness-50"
                    : "";

                  return (
                    <div
                      key={item.name}
                      className={`cursor-pointer ${shouldGrayOut}`}
                      onClick={() => {
                        if (isActive && isAvailable) {
                          window.open(item.link, "_blank");
                        }
                      }}
                    >
                      {getSvgOrImage(item.name)}
                    </div>
                  );
                });
              })()}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
